import React, { useEffect, useRef, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { makeStyles } from '@mui/styles';
import { Grid, Button, Box } from '@mui/material';
import { toFilterVOS, filterVOStoQueryStr } from 'components/FilterPod';
import { useExportFile } from 'hooks';
import { PageContainer, FilterPod, TableComponents, LoadingPage, ExportButton, Icons } from 'components';
import useCustomHook from './hooks';
import { getDynamicObjectAction, constBreadCrumbsTitle } from 'utility';
import DiscountCodesServices from './services/DiscountCodesServices';
import { columns, generateData } from './components/Columns';
import FilterButton from 'components/FilterPod/FilterButton';
import jMoment from 'moment-jalaali';
import axios from 'axios';
import { useCurrencyUnit } from 'hooks';

import {
  getExportCreditVoucherUrl,

} from 'URLs';
const AssignedDelegation = () => {
  // -- STATES --//
  const {
    filterParams,
    setFilterParams,
    loading,
    setLoading,
    setGuildsList,
    guildListLoading,
    setGuildListLoading,
    filters,
    setFilters,
    size,
    setSize,
    page,
    setPage,
  } = useCustomHook();

  // --HOOKS--//
  const classes = useStyles();
  const tableRef = useRef();
  const { downloadFile, isExporting } = useExportFile({
    url: getExportCreditVoucherUrl(),
    filename: 'credit-voucher-guild',
  });
  const currencyText = useCurrencyUnit(false);

  const [openFilterDialog, setOpenFilterDialog] = useState(false);
  const handleCloseFilterDialog = () => setOpenFilterDialog(false);
  /**
     * لیست اکشن ها رو برمیگرداند . به ازای هر اکشن ، درصورتیکه دسترسی داشته باشد ترو و دسترسی نداشته باشد فالز است
     */
  const actionsList =
    getDynamicObjectAction([
      'creditVoucherList',
      'creditVoucherDetailAction',
      'creditVoucherExportBtn',
      'toggleListCreditVoucher'
    ]);
  useEffect(() => {
    if (actionsList['creditVoucherList']) {
    
      const getGuildsList = async (val = '') => {
        setGuildListLoading(false);
        try {
          const q = { query: encodeURI(val) };
          const result = await DiscountCodesServices.getGuildsList(q);
          const data = result.result.guilds;

          if (data.length > 0) {
            let list = [];
            list = data.map((val) => ({
              name: val.name,
              id: val.id,
              label: val.name,
              value: val.id,
              code: val?.code,
            }));
            setGuildsList(list);

            const tempFilters = [...filters];
            const i = tempFilters.findIndex((v) => v?.keyName === 'guildCode');
            if (i < 0) return;
            tempFilters[i] = {
              ...tempFilters[i],
              filterProps: {
                ...tempFilters[i].filterProps,
                options: [...list.map((v) => ({ label: v?.name, value: v?.code }))],
              },
            };
            setFilters(tempFilters);

            setGuildListLoading(false);
          }
        } catch (e) {
          setGuildListLoading(false);
        }
      };

      getGuildsList(); // used for filters
    }

  }, []);

  // --API REQUESTS--//
  const getDicsountCodes = async (query) => {
      

    try {
      setLoading(true);

      // TODO: Handle Order By (is not provided by server side)
      const orderBy = [];

      const filter = toFilterVOS([...filters]);
      const queries = filterVOStoQueryStr(filter);
      queries.type = 1;

      jMoment.loadPersian({ usePersianDigits: false });

      const params = {
        offset: query ? query?.pageNumber * query?.pageSize : page * size,
        size: query ? query?.pageSize : size,
        startDate: '1396/01/01 00:00:00',
        endDate: jMoment(new Date().setHours(23, 59, 0, 0)).format('jYYYY/jMM/jDD 23:59:59'),
        ...queries,
      };

      const data = {
        filterVOS: filter ?? [],
        parentParams: [],
        orderByElementVOS: orderBy ?? [],
      };

      setFilterParams({ data, params });

      const res = await DiscountCodesServices.getVourchers(params);
      let list = [];
      if (res.result) {
        list = generateData(res.result, {
          page: query ? query?.pageNumber : page,
          pageSize: query?.pageSize || size,
        });
      }

      setLoading(false);

      const d = {
        data: list,
        page: query ? query?.pageNumber : page,
        totalCount: res?.count,
      };
      return d; // passed to MaterialTable
    } catch (error) {
      if (axios.isCancel(error)) {
        setLoading(true);
      } else {
        setLoading(false);
        return {
          data: [],
          page: query ? query?.pageNumber : page,
          totalCount: 0,
        };
      }
    }
  };

  const onChangeStatus = async (id, newStatus) => {
    try {
      await DiscountCodesServices.changeVoucherStatus(id, newStatus);
      tableRef?.current?.onChangeTable();
    } catch (error) {
      setLoading(false);
    }
  };

  const onExport = (type) => {
    downloadFile(type, filterParams?.data, filterParams?.params);
  };

  // -- OTHER FUNCTIONS --//
  const onFiltersChange = (newFilters) => {
    setFilters(newFilters);
    setPage(0);
    setSize(10);
    setTimeout(() => {
      tableRef?.current?.onChangeTable(true);
    }, 100);
  };

  const hint = 'در این بخش می‌توانید لیست بن‌های شارژ صادر‌ شده توسط کسب‌وکار را مشاهده کنید.';

  return (
    <PageContainer
      title="لیست بن‌های شارژ"
      description={hint}
      breadcrumbs={constBreadCrumbsTitle.CREDIT_VOUCHER_LIST}
      className={classes.root}
    >
      <Grid item xs={12}>
        <Box display="flex" justifyContent='end' alignItems="flex-end" style={{ marginBottom: 16 }}>
          {
            actionsList['creditVoucherList'] &&
            <FilterButton
              setOpenFilterDialog={setOpenFilterDialog}
              filters={filters}
            />
          }
          {
            actionsList['creditVoucherExportBtn'] &&
            <ExportButton
              loading={isExporting}
              types={['xls', 'csv']}
              onExport={onExport}
            />
          }
        </Box>
        <Box>
          <FilterPod
            filters={filters}
            onChange={onFiltersChange}
            openFilterDialog={openFilterDialog}
            setOpenFilterDialog={setOpenFilterDialog}
            handleCloseFilterDialog={handleCloseFilterDialog}
          />
        </Box>
      </Grid>
      {guildListLoading ? (
        <LoadingPage />
      ) : (
       (actionsList['creditVoucherList'] && currencyText) && <TableComponents
          data={getDicsountCodes}
          columns={columns(SeeDetailBtn, onChangeStatus, actionsList , currencyText)}
          isLoading={loading}
          ref={tableRef}
          onChange={(ps) => {
            setPage(ps?.pageNumber);
            setSize(ps?.pageSize);
            return getDicsountCodes(ps);
          }}
        />
      )}
    </PageContainer>
  );
};

// See detail for every row

const SeeDetailBtn = ({ id }) => {
  const classes = useStyles();
  return (
    <RouterLink to={`/CreditVoucher/${id}`}>
      <Button startIcon={<Icons icon="MoreHorizontal" color="#667585" size="20" />}
        variant="contained" className={classes.expandBtn}>
        جزئیات
      </Button>
    </RouterLink>
  );
};

const useStyles = makeStyles((theme) => ({
  root: {
    '& .MuiTable-root': {
      border: 'solid 1px rgba(109, 114, 120, 0.18)',
      borderRadius: 4,
    },
    '& .MuiTableRow-head th:first-child': {
      borderTopLeftRadius: 4,
    },
    '& .MuiTableRow-head th:last-child': {
      borderTopRightRadius: 4,
      width: 145,
    },
  },
  expandBtn: {
    border: `1px solid #2b3990`,
    padding: theme.spacing(2),
    margin: 0,
    background: 'white',
    color: '#2b3990',
    '&:hover': {
      background: '#2b3990',
      color: '#fff',
    },
  },
  props: {
    padding: theme.spacing(2, 3),
    boxSizing: 'border-box',
  },
  tickIcon: {
    color: '#43A047',
    fontSize: 17,
  },
  tickItem: {
    marginBottom: theme.spacing(1),
  },
  propsTitle: {
    color: '#2b3940',
    fontWeight: 'bold',
    fontSize: 12,
    marginBottom: theme.spacing(1.5),
  },
  tickText: {
    fontSize: 12,
    fontWeight: 'normal',
    marginInlineStart: theme.spacing(1),
    color: '#2b3940',
  },
}));

export default AssignedDelegation;
